export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/business.e61a3ab.svg";